import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsuranceControlContainer } from '@app/my-zone/shared/insurance-control/insurance-control.container';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { InsuranceModule } from '@app/shared/insurance/insurance.module';
import { DownloadingModalModule } from '@app/shared/modals/downloading';
import { DetailsAccordionModule } from '@app/shared/ux/accordion/details-accordion.module';
import { NewModalModule } from 'outshared-lib';
import { InsuranceControlComponent } from './insurance-control.component';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@NgModule({
    imports: [
        CommonModule,
        NewModalModule,
        DetailsAccordionModule,
        InsuranceModule,
        DirectivesModule,
        DownloadingModalModule,
    ],
    declarations: [
        InsuranceControlComponent,
        InsuranceControlContainer,
    ],
    exports: [
        InsuranceControlContainer,
    ],
})
export class InsuranceControlModule {}
